import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openButton", "closeButton"]

  connect() {
    // Ensure menu starts closed
    this.closeMenu()
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.openMenu()
    } else {
      this.closeMenu()
    }
  }

  openMenu() {
    this.menuTarget.classList.remove("hidden")
    this.openButtonTarget.classList.add("hidden")
    this.closeButtonTarget.classList.remove("hidden")
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden")
    this.openButtonTarget.classList.remove("hidden")
    this.closeButtonTarget.classList.add("hidden")
  }

  // Close menu when clicking outside
  outsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.closeMenu()
    }
  }
}